<template lang="pug">
  div
    form(ref="saveDesignForm" :action="action_url" method="POST" @submit.prevent="onSave")
      div.d-flex
        input#html_name.form-control(style="width: 75%; height: 30px;", type='text', name='design_name', v-model='html_name', placeholder='デザインの保存名')
        input(type="hidden" name="_method" value="PATCH")
        input(type="hidden" name="design_id" v-model='design_id')
        button.btn.btn-success.btn-sm.ml-2(v-if="image_mode && reserved" class="disabled" type='submit') 保存
        button.btn.btn-success.btn-sm.ml-2(v-else type='submit') 保存
    div.d-flex.align-items-center
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  </template>

<script>
//libs
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

export default {
  props: {
    action_url: {type: String, default: "" },
    is_upper_master: {type: Boolean, default: false },
    image_mode: {type: Boolean, default: false },
    reserved: {type: Boolean, default: false },
    design_id: {type: Number, default: 0 },
    design_name: {type: String, default: "" },
    saved_count: {type: Number, default: 0 },
  },
  methods: {
    async onSave(){
      if (!this.is_upper_master){
        this.is_upgrade_upper_master_modal = true
        return
      }

      if (this.image_mode && this.reserved){
        return
      }
      
      if(this.design_name!==""){
        this.$toasted.error("このWebサイトデザインは既に保存済みです。")
        await sleep(10000)
        this.$toasted.clear()
        return
      }
      if(this.saved_count >= 4){
        this.$toasted.error("「保存」ボタンで保存されたデザイン数の上限が４つです。「デザイン更新」ボタンで保存されたデザインが１つ、合計５つです。")
        await sleep(10000)
        this.$toasted.clear()
        return
      }
      this.$refs.saveDesignForm.submit()
    },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
      html_name: "",
    }
  },
  components: {
    UpgradeUpperMaster,
  },
}
</script>

